module.exports = __webpack_public_path__ + "img/guest-icon.d9fdfa42.png";